export default "__VITE_ASSET__DYgu8lTl__"